"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UIList = _interopRequireDefault(require("../list/UIList"));

/**
 * Group clusters of Radio/Checkbox Buttons together, with common styling
 **/
var _default = _react.default.createClass({
  displayName: "UIToggleGroup",
  propTypes: {
    children: _propTypes.default.node.isRequired,
    inline: _UIList.default.propTypes.inline,
    name: _propTypes.default.string.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      inline: _UIList.default.defaultProps.inline
    };
  },
  render: function render() {
    /* eslint-disable react/prop-types */
    var _this$props = this.props,
        children = _this$props.children,
        __error = _this$props.error,
        name = _this$props.name,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "error", "name"]);
    return _react.default.createElement(_UIList.default, rest, _react.default.Children.map(children, function (child) {
      var clone = _react.default.cloneElement(child, (0, _extends2.default)({
        name: name
      }, child.props));

      return clone;
    }));
  }
});

exports.default = _default;
module.exports = exports.default;